import React, { FC } from 'react';
import './style.scss';

const Proxy: FC = () => {
    return (
        <div className="">
            <div className="top">
                <div className="titles">
                    <div className="header">Total Proxies</div>
                    <div className="detail">5587</div>
                </div>
            </div>
        </div>
    )
}

export default Proxy;
